import React from "react";

/** Brand glyphs for cloud providers — tiny, monochrome-friendly. */
export function GoogleDriveIcon({ className = "h-4 w-4" }) {
  return (
    <svg viewBox="0 0 87.3 78" className={className} xmlns="http://www.w3.org/2000/svg">
      <path d="M6.6 66.85l3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3L27.5 53H0c0 1.55.4 3.1 1.2 4.5z" fill="#0066da"/>
      <path d="M43.65 25L29.9 1.2c-1.35.8-2.5 1.9-3.3 3.3L1.2 48.5c-.8 1.4-1.2 2.95-1.2 4.5h27.5z" fill="#00ac47"/>
      <path d="M73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.5l5.85 11.5z" fill="#ea4335"/>
      <path d="M43.65 25l13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2H34.4c-1.6 0-3.15.45-4.5 1.2z" fill="#00832d"/>
      <path d="M59.8 53H27.5L13.75 76.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z" fill="#2684fc"/>
      <path d="M73.4 26.5L60.75 4.5c-.8-1.4-1.95-2.5-3.3-3.3L43.65 25l16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z" fill="#ffba00"/>
    </svg>
  );
}

export function OneDriveIcon({ className = "h-4 w-4" }) {
  return (
    <svg viewBox="0 0 32 32" className={className} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.2 11.4l.1.1 4.6-2c1-.5 2.2-.7 3.4-.5-.2-1.1-.8-2.2-1.6-3-.9-1-2.2-1.7-3.6-1.9-1.4-.3-2.9 0-4.2.7-.8.5-1.5 1.1-2 1.9-.5.8-.8 1.7-.9 2.6.3 0 .6 0 .9.1 1.2.2 2.3.7 3.3 2z"
        fill="#0364B8"
      />
      <path
        d="M12.3 11.5C11.4 10.5 10.3 10 9.1 9.8c-.3 0-.6-.1-.9-.1-1.6 0-3.2.6-4.4 1.6-1.2 1-2 2.4-2.3 4 .7-.5 1.4-.9 2.2-1.2.8-.3 1.6-.4 2.5-.4 1 0 2 .2 3 .6l1.7-1.7c.4-.5.9-.8 1.4-1.1z"
        fill="#0078D4"
      />
      <path
        d="M20.3 9c-1.2-.2-2.5 0-3.6.5l-4.6 2c.4-.4.9-.8 1.5-1l-.1-.1c1.1.6 2.1 1.6 2.8 2.7l1.9-.7c.7-.3 1.4-.4 2.1-.4 1.5 0 2.9.5 4 1.5-.1-1.2-.5-2.3-1.2-3.2-.7-.8-1.7-1.3-2.8-1.3z"
        fill="#28A8EA"
      />
      <path
        d="M24.4 12.5c-1.1-1-2.5-1.5-4-1.5-.7 0-1.4.1-2.1.4l-1.9.7c.3.5.6 1 .8 1.6.2.5.3 1.1.4 1.7v.7c0 .7-.1 1.3-.4 2-.2.6-.5 1.2-.9 1.7h6c.8 0 1.6-.2 2.3-.6.7-.4 1.3-.9 1.8-1.6.5-.7.7-1.4.8-2.2.1-.8 0-1.6-.3-2.3-.3-.2-.5-.4-.7-.6z"
        fill="#50D9FF"
      />
      <path
        d="M9.2 14.3c-.9 0-1.7.1-2.5.4-.8.3-1.5.7-2.2 1.2-.6.5-1.1 1.1-1.5 1.8-.4.7-.6 1.5-.7 2.3-.1.8 0 1.6.3 2.4.2.8.6 1.5 1.2 2 .6.6 1.2 1 2 1.3.7.3 1.5.4 2.3.4h8.1c.5-.5.8-1.1 1-1.7.3-.6.4-1.3.4-2v-.7c0-.6-.2-1.2-.4-1.7-.2-.6-.5-1.1-.8-1.6-.7-1.1-1.7-2-2.8-2.7-1-.4-2-.6-3.1-.6z"
        fill="#0078D4"
      />
    </svg>
  );
}

export function DropboxIcon({ className = "h-4 w-4" }) {
  return (
    <svg viewBox="0 0 32 32" className={className} xmlns="http://www.w3.org/2000/svg">
      <path d="M8 2 L16 7 L8 12 L0 7 Z" fill="#0061FF"/>
      <path d="M24 2 L32 7 L24 12 L16 7 Z" fill="#0061FF"/>
      <path d="M8 22 L16 17 L24 22 L16 27 Z" fill="#0061FF"/>
      <path d="M0 17 L8 12 L16 17 L8 22 Z" fill="#0061FF"/>
      <path d="M16 17 L24 12 L32 17 L24 22 Z" fill="#0061FF"/>
    </svg>
  );
}

export default function ProviderIcon({ provider, className = "h-4 w-4" }) {
  if (provider === "microsoft") return <OneDriveIcon className={className} />;
  if (provider === "dropbox") return <DropboxIcon className={className} />;
  return <GoogleDriveIcon className={className} />;
}
